import * as domainTask from 'domain-task';

const addTask = domainTask.addTask;
const fetch = domainTask.fetch;

export { fetch, addTask };
